import Splide from '@splidejs/splide';

export const testimonialSlider = () => {
  const splideContainer = document.querySelector('.testimonial-slider');

  if (!splideContainer) return;

  const splide = new Splide(splideContainer, {
    perMove: 1,
    perPage: 1,
    rewind: true,
    arrows: false,
    autoplay: true,
    cloneStatus: true,
    interval: 10000,
    pagination: false,
    pauseOnHover: false,
    pauseOnFocus: false,
  });

  splide.mount();

  const nextSlide = document.querySelectorAll('.js-slider-next');
  const prevSlide = document.querySelectorAll('.js-slider-prev');

  nextSlide.forEach((item) => {
    item.addEventListener('click', function () {
      splide.go('>');
    });
  });
  prevSlide.forEach((item) => {
    item.addEventListener('click', function () {
      splide.go('<');
    });
  });

  const counter = document.querySelector('.js-slider-counter');

  splide.on('moved', (newIndex) => {
    if (counter !== null) {
      counter.textContent = `${newIndex + 1}`;
    }
  });
};
